import {
  BsEnvelope,
  BsTelephone,
  BsGeoAlt,
  BsCheckCircle,
} from "react-icons/bs";

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">START A CONVERSATION</span>

          <h2>Talk Directly With Adyah</h2>

          <p>
            Whether you need a website, marketing strategy or AI automation,
            we'll help identify the right solution for your business.
          </p>
        </div>

        <div className="row g-5 align-items-stretch">
          {/* LEFT SIDE */}

          <div className="col-lg-5">
            <div className="contact-info">
              <h3>Free Strategy Consultation</h3>

              <p>
                Every inquiry is personally reviewed to understand your goals,
                challenges and growth opportunities.
              </p>

              <div className="contact-item">
                <BsEnvelope />
                <span>team@adyah.co.in</span>
              </div>

              <div className="contact-item">
                <BsTelephone />
                <span>+91 98676 72919</span>
              </div>

              <div className="contact-item">
                <BsGeoAlt />
                <span>Mumbai, Maharashtra, India</span>
              </div>

              <div className="contact-divider"></div>

              <div className="contact-benefits">
                <div>
                  <BsCheckCircle />
                  Free Initial Consultation
                </div>

                <div>
                  <BsCheckCircle />
                  Business Focused Solutions
                </div>

                <div>
                  <BsCheckCircle />
                  Direct Founder Consultation
                </div>
              </div>

              <div className="founder-box">
                <h5>Paras Lalan</h5>

                <span>Founder, Adyah Consultancy Services</span>

                <p>
                  Every project begins with understanding your business
                  objectives before recommending technology, marketing or
                  automation solutions.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}

          <div className="col-lg-7">
            <div className="contact-form">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                    />
                  </div>
                </div>

                <input
                  type="text"
                  className="form-control mb-4"
                  placeholder="Phone Number"
                />

                <div className="service-selection">
                  <label className="service-option">
                    <input type="radio" name="service" />
                    Website Development
                  </label>

                  <label className="service-option">
                    <input type="radio" name="service" />
                    Social Media Marketing
                  </label>

                  <label className="service-option">
                    <input type="radio" name="service" />
                    AI Automation
                  </label>

                  <label className="service-option">
                    <input type="radio" name="service" />
                    Multiple Services
                  </label>
                </div>

                <textarea
                  className="form-control mt-4"
                  placeholder="Tell us about your project, goals and requirements..."
                ></textarea>

                <button
                  type="submit"
                  className="btn-primary-custom contact-btn"
                >
                  Discuss My Project
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
